import { Box, Typography } from "@mui/material";
import { PartnerMetricsTile } from "./PartnerMetricsTile";
import type { PartnerMetricsRow } from "../metrics.types";

interface PartnerMetricsTilesProps {
  rows: PartnerMetricsRow[];
  onSelectPartner: (id: string) => void;
}

/**
 * Mobile alternative to `PartnerMetricsTable` — one `PartnerMetricsTile` per
 * row, in whatever order/sort the rows already arrive in. `MetricsDashboardPage`
 * swaps to this automatically below the `sm` breakpoint; there's no
 * user-facing table/tile toggle (CPD-67 — twosion-ui's own dense-table
 * mobile answer is "default to tiles," not a switch users reach for).
 */
export function PartnerMetricsTiles({ rows, onSelectPartner }: PartnerMetricsTilesProps) {
  if (rows.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ py: 2, textAlign: "center" }}>
        No partners match the current filters.
      </Typography>
    );
  }

  return (
    <Box sx={{ display: "grid", gap: 1.5, p: 1.5 }}>
      {rows.map((row) => (
        <PartnerMetricsTile key={row.id} row={row} onSelectPartner={onSelectPartner} />
      ))}
    </Box>
  );
}
